import { TTeamInvitationDto } from '@app-velocity/av-api-v2';

import { SingleInvitation } from './components/SingleInvitation';

export type NotificationListProps = {
  notifications: TTeamInvitationDto[];
};

export const NotificationsList = ({ notifications }: NotificationListProps) => {
  return (
    <>
      {notifications.map((invitation) => (
        <SingleInvitation key={invitation.id} invitation={invitation} />
      ))}
    </>
  );
};
